import { render, staticRenderFns } from "./contentCompanyAccess.vue?vue&type=template&id=366f1115&"
import script from "./contentCompanyAccess.vue?vue&type=script&lang=js&"
export * from "./contentCompanyAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports